import { Component, OnInit, ViewChild } from '@angular/core';
import { DetailComponent } from './../detail/detail.component';

@Component({
  selector: 'app-transformer',
  templateUrl: './transformer.component.html',
  styleUrls: ['./transformer.component.scss']
})
export class TransformerComponent implements OnInit {

  @ViewChild(DetailComponent) detail: DetailComponent;

  title = 'API Transformers';
  cardType = 'transformer';
  buttonType = 'transformer';

  apiTransformers = [
      {
        title : 'Swagger to API',
        image : './assets/img/transformer/swaggerToApi.png',
        caption : '',
        count : '',
        documentRoute: '/docs/',
        doctitle: 'Open%20API%20to%20API',
        createRoute : '/openapitoapi',
        apiRoute: 'create-from-yaml'
      },
      {
        title : 'Database to API',
        image : './assets/img/transformer/databaseToApi.png',
        caption : '',
        count : '',
        documentRoute: '/docs/',
        doctitle: 'Database%20to%20API',
        createRoute : '/digital-transformer',
        apiRoute: 'create-from-database'
      },
      {
        title : 'Data API to API',
        image : './assets/img/transformer/dataToApi.jpg',
        caption : '',
        count : '',
        documentRoute: null,
        doctitle: '',
        createRoute : '/dataaccessapi',
        apiRoute: 'create-from-api'
      },
      {
        title : 'COBOL to API',
        image : './assets/img/transformer/cobolToApi.jpg',
        caption : '',
        count : '',
        documentRoute: null,
        doctitle: '',
        createRoute : '/console',
        apiRoute: '/console'
      },
      {
        title : 'SQL Query to API',
        image : './assets/img/transformer/sqlToApi.png',
        caption : '',
        count : '',
        documentRoute: '/docs/',
        doctitle: '',
        createRoute : '/querybuilder',
        apiRoute: 'create-from-database-table'
      }
    ];

  constructor() { }

  ngOnInit(): void {
  }

}
